import Phaser from 'phaser';
import { FONT_BODY, applyStrongShadow } from './Typography';

// === TEXTE FLOTTANT ANIMÉ ===
// Affiche un texte qui monte et disparaît (feedback visuel).

/** Affiche un texte flottant qui monte et s'efface */
export function showFloatingText(
  scene: Phaser.Scene,
  x: number,
  y: number,
  text: string,
  color: string = '#f1c40f',
  duration: number = 1200,
): void {
  const txt = scene.add.text(x, y, text, {
    fontSize: '14px',
    color,
    fontFamily: FONT_BODY,
    fontStyle: 'bold',
  }).setOrigin(0.5).setDepth(100);
  applyStrongShadow(txt);

  scene.tweens.add({
    targets: txt,
    y: y - 40,
    alpha: 0,
    duration,
    ease: 'Power2',
    onComplete: () => txt.destroy(),
  });
}

/** Affiche un texte de récompense avec rebond */
export function showRewardText(
  scene: Phaser.Scene,
  x: number,
  y: number,
  text: string,
  color: string = '#2ecc71',
): void {
  const txt = scene.add.text(x, y, text, {
    fontSize: '16px',
    color,
    fontFamily: FONT_BODY,
    fontStyle: 'bold',
  }).setOrigin(0.5).setDepth(100).setScale(0.5);
  applyStrongShadow(txt);

  scene.tweens.add({
    targets: txt,
    scaleX: 1.2,
    scaleY: 1.2,
    duration: 200,
    ease: 'Back.easeOut',
    yoyo: true,
    onYoyo: () => {
      scene.tweens.add({
        targets: txt,
        y: y - 30,
        alpha: 0,
        duration: 800,
        delay: 400,
        ease: 'Power2',
        onComplete: () => txt.destroy(),
      });
    },
  });
}
